/*
TODO
Change the validation token to production before release!
Remove console.log before release!
Maybe change the function name getInitial to something more relevant? Not important

In update members make it so that it will display all the errors at once instead of only displaying a single error for one field at a time.
*/

import React, {useState} from 'react';
import ReactLoading from 'react-loading';
import { useAlert } from 'react-alert';
import DatePicker from 'react-date-picker/dist/entry.nostyle';

export const PersonalDetails = (props, onClick) => {
    /*                       STATES START                            */

    //Sets the hidden state of the back and save button
    const [hideButton, setHideButton] = React.useState(false);

    //Sets the response data and whether the postal is same as residential
    const [responseData, setResponseData] = React.useState('');
    const [sameAddress, setSameAddress] = React.useState(false);

    //Checks if the user edited either the residential or postal
    const [addressEdited, setAddressEdited] = useState(false);
    // const [resEdited, setResEdited] = useState(false);

    //Stores the user input in the form, used to search for the address
    const [findAddress, setFindAddress] = useState('');
    const [findPostal, setFindPostal] = useState('');

    //Sets the dropdown menu for the suggested addresss
    const [items, setItems] = useState([]);
    const [postalItems, setPostalItems] = useState([]);

    //Stores the return address results from the API
    const [results, setResults] = useState([]);
    const [postalResults, setPostalResults] = useState([]);

    //Handles the hidden state of the address select box
    const [noAddressOptions, setNoAddressOptions] = useState(true);
    const [noPostalOptions, setNoPostalOptions] = useState(true);

    //Sets the state of the invalid icons
    // const [invalidPhone, setInvalidPhone] = useState(true);
    const [invalidAddress, setInvalidAddress] = useState(true);
    const [invalidPostal, setInvalidPostal] = useState(true);
    const [invalidMobile, setInvalidMobile] = useState(true);
    const [invalidHomePhone, setInvalidHomePhone] = useState(true);
    const [invalidEmail, setInvalidEmail] = useState(true);
    const [invalidOccupation, setInvalidOccupation] = useState(true);


    //Sets the loading state
    const [notLoading, setNotLoading] = useState(true);

    const [occupations, setOccupations] = useState([]);
    const [displayCustomOccupation, setDisplayCustomOccupation] = useState(false);
    const [gender, setGender] = useState('');
    const [dob, setDob] = useState('');

    /*                       STATES END                            */

    /*                       USEEFFECT START                            */

    React.useEffect(() => {
        setInvalidMobile(props.invalidPhone);
        setInvalidHomePhone(props.invalidHomePhone);
        setInvalidEmail(props.invalidEmail);
    }, [props.invalidPhone, props.invalidEmail, props.invalidHomePhone]);
    
    //Gets the member details from the API and sets the forms default values
    React.useEffect(() => {
        if(!props.notSignUp){
            setGender(props.responseData.gender);
            setDob(props.responseData.dob);
        }

        //If the address is null or empty then do not set the address
        if(props.responseData.addr1 === "" || props.responseData.addr1 === null){
            props.responseData.defaultPostalAddress = null;
            props.responseData.residentialAddress = null;
        }
        setOccupations(props.occupations);
        setHideButton(props.hideButton)
        setResponseData(props.responseData);
        setSameAddress(props.sameAddress);
        setItems(props.items);
        setPostalItems(props.postalItems);
        setResults(props.results);
        setPostalResults(props.postalResults);
        setNoAddressOptions(props.noAddressOptions);
        setNoPostalOptions(props.noPostalOptions);

        //If current job title does not exist in the occupation list then display the custom occupation instead
        if(props.occupations.filter(e => e.name === props.responseData.jobTitle).length === 0 && props.notSignUp){
            setDisplayCustomOccupation(true);
            occupation.current.value = props.responseData.jobTitle;
        } else {
            setDisplayCustomOccupation(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.responseData, props.occupations]);

    React.useEffect(() =>{
        if(!props.isEdited && responseData.defaultPostalAddress){
            getInitial(responseData.defaultPostalAddress, true, 1); 
            getInitial(responseData.residentialAddress, true, 2);
        }
            
        // console.log("Inital Saving");
        formChange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [responseData, setResponseData]);

    //Two blocks below will be triggered whenever the user enters in their address in the forms
    React.useEffect(() => {
        if(findPostal.length > 5){
            getInitial(findPostal, false, 1);
        }
    }, [findPostal]);

     React.useEffect(() => {
         if(findAddress.length > 5){
            getInitial(findAddress, false, 2);   
         }
    }, [findAddress]);

    React.useEffect(() =>{
        formChange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sameAddress])

    React.useEffect(() =>{
        formChange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gender])

    React.useEffect(() =>{
        formChange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dob])

    /*                       USEEFFECT END                            */

    /*                       FUNCTIONS START                            */

    //Returns the validated address options
    function getInitial(address, invisible, id){
        var addressQuery = address.replace(/\s/g, '%20');
        fetch(localStorage.getItem('server') + 'api/app/addressr?query=' + addressQuery, {
            method: 'GET'
        })
        .then(function(resp){
            return resp.json();
        })
        .then(function(data){
            //If it returns an address, populate the select list
            if(data.addresses.length > 0){
                var addressArray = [];
                var resultsArray = [];
                data.addresses.forEach(function(result){
                    addressArray.push(result.sla);
                    resultsArray.push(result);
                });

                if(id === 1){
                    setPostalItems(addressArray);
                    setPostalResults(resultsArray);
                    setNoPostalOptions(invisible);
                } else {
                    setItems(addressArray);
                    setResults(resultsArray);
                    setNoAddressOptions(invisible);
                }
            } else {
                if(id === 1){
                    setNoPostalOptions(true);
                } else {
                    setNoAddressOptions(true);
                }
            }
        })
    }

    //Same address toggle state and sets the postal address to be the same as residental address if it is ticked
    const toggleAddress = () => {
        setAddressEdited(true);
        setSameAddress(!sameAddress);
        if(sameAddress === false){
            postalAddr.current.value = residentalAddr.current.value;
        } else {
            // residentalAddr.current.value = '';
            postalAddr.current.value = '';
        }
    }

    //Sets the address to use when making the address validation api call.
    const onChangeAddress = (event) => {
        setAddressEdited(true);
        // setResEdited(true);
        setFindAddress(event.currentTarget.value);
    }

    const onChangePostal = (event) => {
        setAddressEdited(true);
        setFindPostal(event.currentTarget.value);
    }

    //Sets the residental address from suggessted and hides the suggestion box
    //If the user checked same as resident then the change will apply to both
    const setAddress = (event) =>{
        // console.log(event.currentTarget.getAttribute("validate"));
        residentalAddr.current.value = event.currentTarget.innerHTML;
        setNoAddressOptions(true);
        // console.log(sameAddress);
        if(sameAddress){
            postalAddr.current.value = event.currentTarget.innerHTML;
        }
        formChange();
    }

    const setPostal = (event) =>{
        // console.log(event.currentTarget.getAttribute("validate"));
        postalAddr.current.value = event.currentTarget.innerHTML;
        setNoPostalOptions(true);
        formChange();
    }

    const alert = useAlert();

    /*                       FUNCTIONS END                            */

    /*                       SUBMIT START                            */

    //Start of form submission    

    var firstName = React.createRef();
    var lastName = React.createRef();
    var email = React.createRef();
    var mobilePhone = React.createRef();
    var homePhone = React.createRef();
    var residentalAddr = React.createRef();
    var postalAddr = React.createRef();
    var occupation = React.createRef();

    const saveFormCheck = (event) =>{
        event.preventDefault();
        setNotLoading(false);

        var formDetails = {
            firstName: firstName.current.value,
            lastName: lastName.current.value,
            email: email.current.value,
            mobile: mobilePhone.current.value,
            homePhone: homePhone.current.value,
            residentalAddress: residentalAddr.current.value,
            postalAddress: postalAddr.current.value,
            occupation: occupation.current.value,
            sameAsResidental: sameAddress,
            addressEdited: addressEdited
            }; 

        // var loopLength = Object.keys(formDetails).length;
        var count = 0;
        var isEmpty = false;

        for(const property in formDetails){
            switch(property){
                case 'email':
                    if(!formDetails[property]){
                        isEmpty = true;
                        setInvalidEmail(false);
                    } else {
                        setInvalidEmail(true);
                    }
                        break;
                case 'mobile':
                    if(!formDetails[property] || formDetails[property].length !== 10){
                        isEmpty = true;
                        setInvalidMobile(false);
                    } else {
                        setInvalidMobile(true);
                    }
                        break;
                case 'occupation':
                    if(!formDetails[property]){
                        isEmpty = true;
                        setInvalidOccupation(false);
                    } else {
                        setInvalidOccupation(true);
                    }
                        break;
                case 'residentalAddress':
                    if(!formDetails[property]){
                        isEmpty = true;
                        setInvalidAddress(false);
                    } else {
                        setInvalidAddress(true);
                    }
                        break;
                case 'postalAddress':
                    if(!formDetails[property]){
                        isEmpty = true;
                        setInvalidPostal(false);
                    } else {
                        setInvalidPostal(true);
                    }
                        break;
                default:
                    break;
            }
            count++;

            //Calls the save form function at the end of the loop
            if(count === 10 && !isEmpty){
                saveForm(formDetails);
            } else if(count === 10){
                setNotLoading(true);
            }
        }
    }

    const saveForm = (formDetails) => {
        //Checks that the address matches one of the returned results
        if (formDetails.addressEdited) {
            //add a check here to determine if only the postal address have been edited
            var isAddressValid = false;
            results.forEach(function (result) {
                if (result.sla.replace(/ /g, "") === formDetails.residentalAddress.replace(/ /g, "")) {
                    isAddressValid = true;
                    formDetails.format = result.pid;
                    formDetails.postalFormat = result.pid;
                }
            });

            if (!isAddressValid) {
                alert.show("Please enter in a valid address", {
                    title: "Invalid Address"
                });
                setInvalidAddress(false);
                setNotLoading(true);
                return;
            }

            if (!formDetails.sameAsResidental) {
                var isPostalValid = false;
                postalResults.forEach(function (postalResult) {
                    if (postalResult.sla.replace(/ /g, "") === formDetails.postalAddress.replace(/ /g, "")) {
                        isPostalValid = true;
                        formDetails.postalFormat = postalResult.pid;
                    }
                });
                if (!isPostalValid) {
                    alert.show("Please enter in a valid postal address", {
                        title: "Invalid Address"
                    });
                    setInvalidPostal(false);
                    setNotLoading(true);
                    return;
                }
            }
        }

        //Sends the form data to the parent page
        props.submit(formDetails, responseData.memberID);

        setNotLoading(true);
    }

    /*                       SUBMIT END                            */

    //Saves the data into the renew component whenever it detects a change. This will not run if the user is on the personal details page.
    const formChange = () =>{
        //If selected occupation is other then display textfield
        if(occupation.current.value.includes('Other')){
            setDisplayCustomOccupation(true);
        }

        if(window.location.pathname !== '/details'){
            try {    
            if(firstName.current.value.length > 32){
                throw new Error('First name is more than 32 characters');
            }
            setHideButton(true);
            var formDetails = {
                firstName: firstName.current.value,
                lastName: lastName.current.value,
                email: email.current.value,
                mobilePhone: mobilePhone.current.value,
                homePhone: homePhone.current.value,
                residentialAddress: residentalAddr.current.value,
                defaultPostalAddress: postalAddr.current.value,
                jobTitle: occupation.current.value,
                sameAsResidental: sameAddress,
                addressEdited: addressEdited
                }; 
            
            //Will save the following details only if the user is on the signup page
            if(window.location.pathname.includes('signup')){
                formDetails.dob = dob;
                formDetails.gender = gender;
            }
    
            props.saveData(formDetails);
            }
            catch (exception) {
                console.error(exception);
            }
            
        }
    }

    //Clear the occupation field
    const resetOccupation = (ev) =>{
        ev.preventDefault();
        occupation.current.value = null;
        setDisplayCustomOccupation(false);
    }
    
    return(
        <div>
            <div className="overlay" hidden={notLoading}>
                <ReactLoading className="loading" type={'cylon'} color={'#61dafb'} height={300} width={300}/>
            </div>

            <div className="container content">
                <div className="personalDetails">
                    <div>
                        <form onChange={formChange}>
                            <div className="row">
                                <div className="col-lg-6">
                                    {!props.notSignUp ? <label className="formLabel">First Name *</label> : <label className="formLabel">First Name</label>}
                                    <input ref={firstName} maxLength="32" className="formInput" disabled={props.notSignUp} type="text" defaultValue={responseData.firstName}></input>
                                </div>

                                <div className="col-lg-6">
                                    {!props.notSignUp ? <label className="formLabel">Last Name *</label> : <label className="formLabel">Last Name</label>}
                                    <input ref={lastName} className="formInput" disabled={props.notSignUp} type="text" defaultValue={responseData.lastName}></input>
                                </div>

                                <div className="col-lg-6" hidden={props.notSignUp} >
                                    {!props.notSignUp ? <label className="formLabel">Gender Identity *</label> : <label className="formLabel">Gender</label>}
                                    <select className="formInput" value={gender} name="gender" onChange={(ev) =>{
                                        setGender(ev.currentTarget.value);
                                    }}>
                                        <option value="" hidden>Please Select</option>
                                        <option value="1">Male</option>
                                        <option value="2">Female</option>
                                        <option value="3">Non-Binary/Gender Fluid</option>
                                    </select>
                                </div>
                                <div className="col-lg-6">
                                    {!props.notSignUp ? <label className="formLabel">Email *</label> : <label className="formLabel">Email *</label>}
                                    <i hidden={invalidEmail} className="fas fa-2x fa-times-circle formInvalidAddress float-right"></i>
                                    <input ref={email} className="formInput" type="text" defaultValue={responseData.email}></input><br/>
                                </div>
                                <div className="col-lg-6" hidden={props.notSignUp}>
                                    {!props.notSignUp ? <label className="formLabel">Date of Birth *</label> : <label className="formLabel">Date of Birth</label>}
                                    <DatePicker calendarIcon="" clearIcon="" className="formInput" onChange={(value) => {setDob(value)}} value={dob}/>
                                </div>
                                <div className="col-lg-6 personal-details-div" >
                                    {!props.notSignUp ? <label className="formLabel">Mobile Phone *</label> : <label className="formLabel">Mobile Phone *</label>}
                                    {/* {props.prefilledMobile !== undefined ?
                                        <input ref={mobilePhone} className="formInput" type="number" defaultValue={props.prefilledMobile} disabled />
                                        : */}
                                        <input ref={mobilePhone} className="formInput" type="number" defaultValue={!props.notSignUp? props.mobileNumber : responseData.mobilePhone} disabled={props.disableMobile} ></input>
                                    {/* } */}
                                    <i hidden={invalidMobile} className="fas fa-2x fa-times-circle formInvalid float-right"></i>
                                </div>

                                <div className="col-lg-6 personal-details-div">
                                    <label className="formLabel">Home Phone</label>
                                    <input ref={homePhone} className="formInput" type="number" defaultValue={responseData.homePhone}></input>
                                    <i hidden={invalidHomePhone} className="fas fa-2x fa-times-circle formInvalid float-right"></i>
                                </div>

                                <div className="col-lg-6 personal-details-div">
                                    <label className="formLabel">Occupation *</label>
                                    {displayCustomOccupation ? 
                                    <div>
                                        <input type="text" placeholder="Enter Occupation" className="formInput" ref={occupation} />
                                        <button className="btn btn-outline-dark occupation-back-btn" onClick={(ev)=>{resetOccupation(ev)}}>X</button>
                                    </div>
                                    :
                                    <select className="formInput" ref={occupation}>
                                        <option value="" disabled={true} selected>Select Occupation</option>
                                        {occupations.map((occupation, index) => 
                                            <option selected={occupation.name === responseData.jobTitle} key={index} value={occupation.name}>{occupation.name}</option>
                                        )}
                                    </select>
                                    }
                                    <i hidden={invalidOccupation} className="fas fa-2x fa-times-circle formInvalid float-right"></i>
                                </div>

                                <div className="col-lg-6">
                                    {!props.notSignUp ? <label className="formLabel">Residential Address *</label> : <label className="formLabel">Residential Address *</label>}
                                    <i hidden={invalidAddress} className="fas fa-2x fa-times-circle formInvalidAddress float-right"></i>
                                    <input ref={residentalAddr} className="formInput" type="text" defaultValue={responseData.residentialAddress} onChange={onChangeAddress}></input>

                                    <div hidden={noAddressOptions} className="suggesstedAddress">
                                    {items.map((item, i) => <p key={i} validate="TestValue" onClick={setAddress}>{item}</p>)}
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    {!props.notSignUp ? <label className="formLabel">Postal Address *</label> : <label className="formLabel">Postal Address *</label>}
                                    <span className="float-right formLabel residentialToggle"><label className="">Same as Residential</label><input onChange={toggleAddress} className="formCheck" checked={sameAddress} type="checkbox"></input></span>
                                    <i hidden={invalidPostal} className="fas fa-2x fa-times-circle formInvalidPostal float-right"></i>

                                    <input ref={postalAddr} className="formInput postalAddressInput" disabled={sameAddress} type="text" onChange={onChangePostal} defaultValue={responseData.defaultPostalAddress}></input>
                                    <div hidden={noPostalOptions} className="suggesstedPostalAddress">
                                    {postalItems.map((postalItem, i) => <p key={i} validate="TestValue" onClick={setPostal}>{postalItem}</p>)}
                                    </div>
                                </div>
                            </div>
                        </form>
                </div>
                <button className="form-btn btn btn-primary float-left formButton" hidden={hideButton} onClick={props.redirectHome}>Back</button>
                {!hideButton &&                 
                    <button id="gtm-personalDetails" className="form-btn btn btn-primary float-right formButton" hidden={hideButton} onClick={saveFormCheck}>Save</button>
                }

                </div>
            </div>
        </div>
    )
}